import brand from '@helpers/brand';
import { Device, from } from '@helpers/media';
import { m } from 'framer-motion';
import styled from 'styled-components';
const Container = styled(m.div) `
  position: absolute;
  bottom: 6px;
  left: 50%;
  display: flex;
  align-items: center;
  background-color: ${brand.green};
  color: ${brand.black};
  padding: 3px 4px;
  border-radius: 4px;
  opacity: 0.65;
  transform: translateX(-50%);
  pointer-events: none;

  svg {
    width: 8px;

    /* Ensure the first 3 chevrons point to the left, not the right */
    &:nth-child(-n + 3) {
      transform: scaleX(-1);
    }

    &:nth-child(4) {
      width: 24px;
      margin: 0 8px;
    }
  }

  @media ${from(Device.TabletLarge)} {
    display: none;
  }
`;
const SwipeIndicatorStyles = {
    Container,
};
export default SwipeIndicatorStyles;
